import { Controller } from "@hotwired/stimulus"

// Tracks signup completion events for ad platforms (Facebook, Microsoft UET)
// and cleans up the URL parameter using history.replaceState.
//
// This controller fires when the page loads with ?sign_up_completed=true,
// which is added by the onboarding flow when a user finishes signing up.
export default class extends Controller {
  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("sign_up_completed") === "true") {
      this.trackSignupCompletion()
      this.cleanUrl()
    }
  }

  trackSignupCompletion() {
    if (window.rails_env === "production") {
      // Delay to ensure tracking scripts are loaded
      setTimeout(() => {
        // Facebook tracking
        if (typeof fbq !== "undefined") {
          fbq("track", "CompleteRegistration")
        }

        // Microsoft UET tracking
        if (typeof window.uetq !== "undefined") {
          window.uetq.push("event", "signup_finish", {})
        }
      }, 5000)
    } else if (window.rails_env === "development") {
      console.info("Facebook Ads tracked: CompleteRegistration")
      console.info("Microsoft Ads tracked: signup_finish")
    }
  }

  cleanUrl() {
    const url = new URL(window.location.href)
    url.searchParams.delete("sign_up_completed")
    history.replaceState({}, "", url.toString())
  }
}
